import React, { useState, useEffect, Alert } from "react"
import { CardText, Col, Row } from "reactstrap"

import DPTextBox from "../../../framework/components/DPTextBox"
import DPDropDown from "framework/components/DPDropDown"

const CustomerMasterTab2 = ({
  fieldManager,
  Address1Value,
  Address1OnChange,
  Address2Value,
  Address2onChange,
  Address3Value,
  Address3OnChange,
  Address4Value,
  Address4onChange,
  AreaValue,
  AreaOnChange,
  Mobile1Value,
  Mobile1OnChange,
  Mobile2Value,
  Mobile2OnChange,
  Phone1Value,
  Phone1OnChange,
  Phone2Value,
  Phone2OnChange,
  FaxValue,
  FaxOnChange,
  EmailVlaue,
  EmailOnChange,
  Disabled,
  show,
  AlertMsg,
  AlertColor

}) => {

  const [area, SetArea] = useState([])


  useEffect(() => {
    const authToken = localStorage.getItem("authToken")
    /**************get area data */
    function getArea() {
      var requestOptions = {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
      };
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}SupplierArea/Select/`, requestOptions)
        .then(response => response.json())
        .then(result => {

          SetArea(result.data)
          let dt = result.data
        }).catch(error => console.log('error', error));
    }
    /**************get area data  End*/

    getArea()

  }, []);
  return (
    <React.Fragment>
      <div>
        <Row>
          <Col sm="12">
            <CardText className="mb-0">
              <Row>
                {show ? (
                  <Alert color={AlertColor} role="alert">
                    {AlertMsg}
                  </Alert>
                ) : null}
                <Col sm={12} md={5} className="mb-5-sm">

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_ADD1')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Address *"
                      textType="text"
                      placeholder="Address Line 1"
                      maxLength="70"
                      value={Address1Value}
                      onChange={Address1OnChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_ADD1')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_ADD2')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="&nbsp;"
                      textType="text"
                      placeholder="Address Line 2"
                      maxLength="40"
                      value={Address2Value}
                      onChange={Address2onChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_ADD2')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_ADD3')}>
                    <DPTextBox
                      rowClass="mb-7-sm"
                      labelText="&nbsp;"
                      textType="text"
                      placeholder="Address Line 3"
                      maxLength="40"
                      value={Address3Value}
                      onChange={Address3OnChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_ADD3')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_ADD4')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="&nbsp;"
                      textType="text"
                      placeholder="Address Line 4"
                      maxLength="40"
                      value={Address4Value}
                      onChange={Address4onChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_ADD4')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_AREA')}>
                    <DPDropDown
                      labelText="Area"
                      rowClass="mb-4-sm"
                      optionGroup={area}
                      selectedGroup={AreaValue}
                      onChange={AreaOnChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_AREA')}
                    />
                  </div>
                </Col>
                <Col sm={12} md={5} className="mb-5-sm">
                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_MOBILE1')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Mobile *"
                      textType="tel"
                      maxLength="15"
                      placeholder="Mobile 1"
                      value={Mobile1Value}
                      onChange={Mobile1OnChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_MOBILE1')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_MOBILE2')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="&nbsp;"
                      textType="tel"
                      maxLength="15"
                      placeholder="Mobile 2"
                      value={Mobile2Value}
                      onChange={Mobile2OnChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_MOBILE2')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_PHONE1')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Phone"
                      textType="tel"
                      maxLength="15"
                      placeholder="Telephone 1"
                      value={Phone1Value}
                      onChange={Phone1OnChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_PHONE1')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_PHONE2')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="&nbsp;"
                      textType="tel"
                      maxLength="15"
                      placeholder="Telephone 2"
                      value={Phone2Value}
                      onChange={Phone2OnChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_PHONE2')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_FAX')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Fax"
                      placeholder="Fax No"
                      textType="text"
                      maxLength="40"
                      value={FaxValue}
                      onChange={FaxOnChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_FAX')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_EMAIL')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Email"
                      textType="text"
                      maxLength="40"
                      value={EmailVlaue}
                      onChange={EmailOnChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_EMAIL')}
                    />
                  </div>
                </Col>
              </Row>
            </CardText>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}
export default CustomerMasterTab2
